import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LabDashboard from "./pages/LabDashboard";
import InstrumentPage from "./pages/InstrumentPage";
import CymaticsStudio from "./pages/CymaticsStudio";
import LaserLab from "./pages/LaserLab";
import PlasmaLab from "./pages/PlasmaLab";
import { getInstrument } from "./lab/instruments";

const InstrumentRoute = () => {
  const { id } = useParams(), ins = getInstrument(id);
  if (!ins) return <Navigate to="/" replace />;
  if (ins.standalone === "laser") return <LaserLab key={id} ins={ins} />;
  if (ins.standalone === "plasma") return <PlasmaLab key={id} ins={ins} />;
  return ins.standalone ? <CymaticsStudio key={id} ins={ins} /> : <InstrumentPage key={id} instrument={ins} />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LabDashboard />} />
        <Route path="/instrument/:id" element={<InstrumentRoute />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster theme="dark" position="top-center" />
    </BrowserRouter>
  );
}

export default App;
